import { render, staticRenderFns } from "./withholdReasonWindow.vue?vue&type=template&id=bc68c5ea&scoped=true&"
import script from "./withholdReasonWindow.vue?vue&type=script&lang=js&"
export * from "./withholdReasonWindow.vue?vue&type=script&lang=js&"
import style0 from "./withholdReasonWindow.vue?vue&type=style&index=0&id=bc68c5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc68c5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc68c5ea')) {
      api.createRecord('bc68c5ea', component.options)
    } else {
      api.reload('bc68c5ea', component.options)
    }
    module.hot.accept("./withholdReasonWindow.vue?vue&type=template&id=bc68c5ea&scoped=true&", function () {
      api.rerender('bc68c5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/releaseControl/withholdReasonWindow.vue"
export default component.exports